/**
 * Class description
 *
 * Created: 2018-04-20
 * @author jonas
 */

import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline, TimelineLite} from "gsap"
import {DungeonQuestSymbolUtil} from "../../utils/DungeonQuestSymbolUtil";
import {StateMatrix} from "../../utils/StateMatrix";
import {DungeonQuestHelper} from "../bigSymbols/DungeonQuestHelper";
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../DungeonQuestSound";
import {DungeonQuestBaseReelSymbol} from "../symbols/DungeonQuestBaseReelSymbol";
import {DungeonQuestBigWinView} from "./DungeonQuestBigWinView";

export class DungeonQuestBigWinController extends StepCountUpBigWinController {

    protected _winSymbols:DungeonQuestBaseReelSymbol[];
    protected _noWinSymbols:StateReelSymbol[];
    private _symbolStates:StateMatrix<string>;
    private _masterTimeLine:Timeline | null;
    private _gameView:DungeonQuestBigWinView;

    constructor(indexes:[number, number]) {
        super(indexes, {skipLastLevelCountUpIfSmall : false});
        this._gameView = new DungeonQuestBigWinView();
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        if(level == 0) {
            this._gameView.preCalculateCountScale(this._gameData!.totalWin);
        }
        const tl:TimelineLite = new TimelineLite();
        const delay:number = level == 0 ? 1.2 : 0; //Wait for symbol animation on firs level.
        const bigWin:TimelineLite = this._gameView.getBigWinLevelAnimation(level, level == this._winLevel);
        tl.add(bigWin, delay);
        return tl;
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin?:number):Timeline | null {
        return this._gameView.getCountUp(from, to, duration);
    }

    protected playBigWinCountUpSound(level:number):void {
    }

    protected playBigWinLevelSound(level:number):void {
    }

    protected playBigWinSound():void {
    }

    protected playEndingAnimation(isAborted:boolean):void {
        if(this._gameData == undefined) {
            debugger;
        }
        const totalWin:number = this._gameData!.totalWin;
        const singleWin:number = this._gameData!.singleWin;
        const tl:TimelineLite = this._gameView.getEndingAnimation(isAborted, this._winLevel, singleWin);
        tl.add(() => SlotGame.sound.stopEffect(DungeonQuestSound.BIG_WIN_WINDUP), 0);
        tl.add(() => SlotGame.winFieldController.showWinField(totalWin), 0);
    }

    protected playSymbolsAnimation():void {
        this._symbolStates = DungeonQuestSymbolUtil.createSymbolStateMatrixFromBetWins(<IBetLineWinData[]>this._betWinsData!);
        this._winSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, DungeonQuestGameConfig.instance.SYMBOL_STATES.win.keyword);
        this._noWinSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, DungeonQuestGameConfig.instance.SYMBOL_STATES.noWin.keyword);

        let tl:TimelineLite = new TimelineLite();

        let noWinSymbolsAnimation:Timeline[] = DungeonQuestSymbolUtil.getSymbolStateAnimations(this._noWinSymbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.noWin, 0.5);
        let winAnimations:Timeline[][] = DungeonQuestSymbolUtil.getSymbolStateAnimationsPerReel(this._winSymbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.win3, 0);

        for(let i:number = 0; i < winAnimations.length; i++) {
            if(winAnimations[i]) {
                let symbolsInReel = new TimelineLite();
                symbolsInReel.add(winAnimations[i], 0, "start", 0.0);
                tl.add(symbolsInReel, 0.0 * i);
            }
        }

        tl.add(noWinSymbolsAnimation, 0);

        let reelHitSoundDelay:number = DungeonQuestHelper.getSymbolWindUpDuration(DungeonQuestHelper.getWinTypeIndex(WinRatioType.BIG_WIN));
        tl.add([
            () => SlotGame.sound.playEffect(DungeonQuestSound.BIG_WIN_WINDUP),
            () => SlotGame.sound.fadeAmbience(0, 1500)
        ], 0);
        tl.add(() => SlotGame.sound.stopEffect(DungeonQuestSound.BIG_WIN_WINDUP), reelHitSoundDelay);

        this._masterTimeLine = tl;
    }

    protected stopAllSounds():void {
    }

    protected stopSymbolsAnimation():void {
        DungeonQuestSymbolUtil.removeFromArrayAndSetStateToNormal(this._winSymbols);
    }
}